import { useMemo } from 'react';

import { formatMenu } from 'olo-service/Menu';
import { MenuDataTransferable } from 'olo-service/Menu/util';
import { useColoResource } from './useColoResource';
import { isSlug } from './isSlug';
import { useTranslation } from 'react-i18next';

export function useGetMenuResource(merchantId?: string, orderType?: string) {
  const { t } = useTranslation();

  const [loading, data, error] = useColoResource<MenuDataTransferable>(() => merchantId && ({
    url: `${merchantId}/menu`,
    params: { slug: isSlug(merchantId), orderType },
  }), [merchantId, orderType]);

  const menu = useMemo(() => data && formatMenu(data, t), [data, t]);

  return { loading, menu, error };
}
